// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DOVaSypaRcC3VNxs1OSe{border-right:1px solid var(--border-neutral-default);width:100%;padding-bottom:64px;overflow:hidden}.DOVaSypaRcC3VNxs1OSe .YWByL9mbE18xO_2gN2kj{justify-content:center;align-items:center;height:100%;padding-right:20px;display:flex}.T3dTcXHWXp8y8uSkEVH8{align-content:start;gap:8px;height:100%;padding-bottom:20px;display:grid;overflow-y:scroll}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listContent": `DOVaSypaRcC3VNxs1OSe`,
	"empty": `YWByL9mbE18xO_2gN2kj`,
	"wrapList": `T3dTcXHWXp8y8uSkEVH8`
};
export default ___CSS_LOADER_EXPORT___;
